import { Observable } from "rxjs";
import { StateService } from "./stateService";

export interface LogoutState {   
    isLogout: boolean;
  }
  
const initialState: LogoutState = {   
    isLogout: false
  };


export class LogoutStateServiceForRoot extends StateService<LogoutState>{
    public static service: LogoutStateServiceForRoot;

    public static getLogoutStateService() : LogoutStateServiceForRoot {
        if ( this.service === undefined) {
            this.service = new LogoutStateServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);
    }
    
    public subscription(): Observable<LogoutState> {
        return this.subscribe();
    }

    public changeLogoutState(logout: LogoutState) : void {
        this.changeState(logout);
    }

    public get getLogoutState(): LogoutState {
        return this.state;
    }
}